import { DesignDialog as Dialog } from "../design/DesignDialog.js";
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = "Confirmation",
  message,
  onCancel,
  onConfirm,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    {title && <DialogTitle>{title}</DialogTitle>}
    <DialogContent>
      <Box sx={{ py: 1 }}>
        <Typography variant="body1" align="center">
          {message}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
      <Button onClick={onCancel} variant="outlined" color="primary">
        {cancelLabel}
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
